/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-29 21:35:04
 * @LastEditors: Aragorn houpengxu@qq.com
 * @LastEditTime: 2022-10-21 21:49:26
 * @Description: 
 */
import yqAnalytics2 from 'yq-analytics'
window.yqAnalytics = yqAnalytics2;
import * as biz2 from './biz.js'
window.biz = biz2;
require("../css/tp1.css");
require("../ua-device/ua-format.js");
require("../ua-device/apple-device.js");
require("./comreq.js");
require("./tp1.js");

// if (location.href.indexOf('zzwkh.irstg.com/h5/tp1.html') > -1) {
//   setTimeout(() => {
//     document.write("<img style='width:100%' src='https://assets.rurushishi.com/tmp/581666337350_.pic_hd.jpg'></img>")
//   }, 1000);
// }


